import React from 'react';
import { isAnyAccessioned } from '../util/gearOrderUtil';

/**
 * Displays an "Add Another Test" button that will drop the user on the Panels page and give them the ability to add a
 * new requisition to the order.
 *
 * @param gearOrder The Gear order
 * @param addNewRequisition A function that will prepare state and move the user to the Panels page
 * @param buttonEl (optional) The button element, overriding the default button
 */
export default function AddAnotherTest({ gearOrder, addNewRequisition, buttonEl }) {
	// Do not show the Add Another Test button when these conditions are met
	if (!canAddAnotherTest(gearOrder, addNewRequisition, buttonEl)) {
		return null;
	}

	if (buttonEl) {
		return buttonEl;
	}

	return (
		<div className="mb-20">
			<button type="button" className="btn btn-add-test btn-primary rounded-pill btn-sm margin-clear" onClick={addNewRequisition}>
				<i className="pe-2 fa fa-plus"></i>Add Another Test
			</button>
		</div>
	);
}

/**
 * Do not show the Add Another Test button when these conditions are met.
 * 
 * Hide "Add Another" button for recollection orders because a second requisition
 * would complicate a lot of the Panel Selection logic ("To Complete Order", pageTitle, etc.).
 * The use case for "Add Another" during a recollection order seems unlikely
 * and not worth the added complexity.
 * 
 * @param gearOrder The Gear order
 * @param addNewRequisition The function to call when another test is added
 * @param buttonEl (optional) The Add Another button element, overriding the default button
 */
export const canAddAnotherTest = (gearOrder, addNewRequisition, buttonEl) => {
	return !(
		!gearOrder?.requisitions?.length ||
		gearOrder.dataConfirmed ||
		isAnyAccessioned(gearOrder) ||
		gearOrder.simplifiedClientBilling ||
		gearOrder.physicianInTheLoop ||
		gearOrder.recollectionFor ||
		(!addNewRequisition && !buttonEl)
	);
}